import { get } from 'lodash';

import SlotSubscriptionEligibility from 'apps/topNavigation/models/SlotSubscriptionEligibility';
import { orManagementLink } from './orLinkBuilder';

export default function redirectSubscribedUser(nextState, replace, path, extras) {
  const { store } = extras;
  const { user } = store.getState();

  if (get(user, 'eligibilityDetails.slotSubscription') === SlotSubscriptionEligibility.HAS_SUBSCRIPTION) {
    replace(orManagementLink(user, false));
  }
}
